<!-- 分页组件 -->
<template>
    <div class="page_box" v-show="total">
        <el-pagination @current-change="handleCurrentChange" :current-page="page"
            :page-sizes="[10, 20, 30, 40]" :page-size="pagesize" layout="total, slot, prev, pager, next" :total="total">
            <span class="select_size">
                每页<el-select @change="pagesizeChange" popper-class="pagesizeSelect" v-model="selfpagesize">
                    <el-option label="10" :value="10"></el-option>
                    <el-option label="20" :value="20"></el-option>
                    <el-option label="30" :value="30"></el-option>
                    <el-option label="40" :value="40"></el-option>
                </el-select>条
            </span>
        </el-pagination>
    </div>
</template>

<script>
export default {
    props: ['total', 'page', 'pagesize','center'],
    data() {
        return {
            selfpagesize: 20
        }
    },
    watch: {
        pagesize: {
            handler(newVal){
                this.selfpagesize = newVal
            },
            immediate: true
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        // this.selfpagesize = this.pagesize
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {
    },
    methods: {
        handleCurrentChange(page) {
            this.$emit('pageChange', page)
        },
        pagesizeChange(selfpagesize) {
            this.$emit('pagesizeChange', selfpagesize)
        }
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .page_box {
        padding-top: 20px;
        display: flex;
        justify-content: flex-end;
        .el-pagination {
            .el-pagination__total {
                font-size: 14px;
                color: #637281;
                position: relative;
                top: 1px;
            }
            .select_size {
                font-size: 14px;
                color: #637281;
                .el-select {
                    height: 28px;
                    width: 60px;
                    margin: 0 6px;
                    .el-input {
                        height: 28px;
                        width: 60px;
                        margin-left: 0;
                        .el-input__inner {
                            height: 28px;
                        }
                        .el-input__suffix {
                            .el-input__suffix-inner {
                                .el-input__icon {
                                    line-height: 28px;
                                }
                            }
                        }
                    }
                }
            }
            .btn-prev {
                margin-left: 20px;
            }
            .btn-next {
                margin-left: 10px;
            }
            .btn-prev, .btn-next {
                min-width: 30px;
                height: 30px;
                padding: 0;
                background: #F0F2F5;
                .el-icon {
                    width: 30px;
                    margin-right: 0;
                }
            }
            .el-pager {
                .number {
                    min-width: 30px;
                    height: 30px;
                    background: #F0F2F5;
                    line-height: 30px;
                    margin-left: 10px;
                    font-size: 14px;
                    &.active {
                        background: #0B75FA;
                        color: #fff;
                    }
                    &:hover {
                        background: #0B75FA;
                        color: #fff;
                    }
                }
            }
        }

    }
</style>